<footer class="footer">
  <div class="container-fluid">
    <div class="footer-content">
      <div class="footer-brand">
        2020 Promokit
      </div>
      <nav class="footer-links footer-legal" aria-label="Documentos jur&iacute;dicos">
        <a href="/termos-de-uso" target="_blank" rel="noopener" aria-label="Termos de Uso (abre em nova aba)">Termos de Uso</a>
        <a href="/contrato-adesao-uso" target="_blank" rel="noopener" aria-label="Contrato de Ades&atilde;o (abre em nova aba)">Contrato de Ades&atilde;o</a>
        <a href="/politica-de-privacidade" target="_blank" rel="noopener" aria-label="Pol&iacute;tica de Privacidade (abre em nova aba)">Pol&iacute;tica de Privacidade</a>
      </nav>
    </div>
  </div>
</footer>
